import React from 'react';
import { Button, Tooltip } from 'antd';
import { connect } from 'react-redux';
import actions from '@flux/action';
import alert from '@components/alert';

const EditButton = ({
  inExpand,
  openModal,
  hasEverUploaded,
  onReset,
  textArea = 'le',
}) => {
  if (!inExpand) {
    return null;
  }

  const wording = {
    resetTip: {
      le: 'Clicking Ok will reset the LE presence & office location to the original dataset, reverting any and all manual changes made to the data. Would you like to proceed with this change?',
      headcount:
        'Clicking Ok will reset Headcount & Sales figures to the original dataset, reverting all previous changes made to the data by users. Would you like to proceed with this change?',
    },
    editTip: {
      le: 'Click "Edit" to export an Excel document of the grid view for LE presence and office locations. In this document, make any necessary edits to the LE presence or office locations for the current state and / or future state tabs. Once your edits are complete, save the Excel file and click "Import" to create an adjusted current state view and / or future state view.',
      headcount:
        'Click "Edit" to export an Excel document of the grid view for Legal Entity data. In this document, make any necessary edits to the first 4 tabs (LE presence tabs) for the current state and / or future state tabs. Once your edits are complete, save the Excel file and click "Import" to create an adjusted current state view and / or future state view.',
    },
  };

  const onResetClick = () => {
    alert.confirm({
      content: wording.resetTip[textArea],
      okText: 'ok',
      onOk: onReset,
      className: 'le-reset-modal',
    });
  };

  return (
    <div className="edit-le-ls-button-wrapper role-control">
      {hasEverUploaded ? (
        <Tooltip title="Revert to original view">
          <Button className="reset-le-button" onClick={onResetClick}>
            <span className="appkiticon icon-refresh-fill" />
          </Button>
        </Tooltip>
      ) : null}
      <Button className="edit-le-ls-button" size="lg" onClick={openModal}>
        edit
      </Button>
      <Tooltip title={wording.editTip[textArea]} placement="bottomLeft">
        <span className="appkiticon icon-information-fill" />
      </Tooltip>
    </div>
  );
};

export default connect(null, (dispatch) => ({
  openModal() {
    dispatch(actions.toggleLeUploadModal(true));
  },
}))(EditButton);
